import { AsyncPipe, NgClass, NgStyle } from "@angular/common";
import { ChangeDetectorRef, Component, OnInit, ViewChild } from "@angular/core";
import { AngularFirestore } from "@angular/fire/compat/firestore";
import { MatDialog } from "@angular/material/dialog";
import { MatProgressSpinner } from "@angular/material/progress-spinner";
import { Data } from "@angular/router";
import { AuthService } from "@core/auth.service";
import { IonicModule } from "@ionic/angular";
import { TranslatePipe, TranslateService } from "@ngx-translate/core";
import { Timestamp } from "firebase/firestore";
import { BehaviorSubject, Observable, Subscription, interval } from "rxjs";
import { first, map } from "rxjs/operators";
import { FortuneMissionsPopupComponent } from "src/app/components/fortune-missions-popup/fortune-missions-popup/fortune-missions-popup.component";
import { SocialService } from "src/app/services/social.service";
import { UserManagementService } from "src/app/services/user-management.service";
import type { SwiperOptions } from "swiper/types";
import { SwiperComponent, SwiperModule } from "swiper/angular";
import { CountDownTimerComponent } from "../../../../count-down-timer/count-down-timer.component";
import { InProgressAnimationComponent } from "../../../../in-progress-animation/in-progress-animation.component";

@Component({
    selector: "app-fortune-missions",
    templateUrl: "./fortune-missions.component.html",
    styleUrls: ["./fortune-missions.component.scss"],
    standalone: true,
    imports: [
        SwiperModule,
        NgClass,
        IonicModule,
        MatProgressSpinner,
        CountDownTimerComponent,
        NgStyle,
        InProgressAnimationComponent,
        AsyncPipe,
        TranslatePipe,
    ],
})
export class FortuneMissionsComponent implements OnInit {
  fortuneMissionData$ = new BehaviorSubject(null);
  getMissionData$ = new BehaviorSubject(null);
  getLeaderPlayerWeek$ = new BehaviorSubject(null);

  @ViewChild("gameMission") public gameMission: SwiperComponent;

  selectedLanguage: string;
  previous: Data;
  previousmonth: Data;
  previousWeek: Data;
  public spanish: boolean;
  public selectedCard!: number;
  public isDisable: boolean;
  buttonText = "Join";
  userAlreadyJoined = false;
  spinnerAnimation: boolean;
  progressBar: number;
  timer$: Observable<number>;
  sub: Subscription;
  proceed = true;
  private mysteryBoxImgUrl: string;
  public userId: string;
  constructor(
    private matDialog: MatDialog,
    public translate: TranslateService,
    private socialservice: SocialService,
    private authService: AuthService,
    private afs: AngularFirestore,
    private socialService: SocialService,
    private changeDetectorRef: ChangeDetectorRef,
    private userManagementService: UserManagementService,
  ) {
    this.isDisable = false;
    this.mysteryBoxImgUrl = "../../../../../../assets/icon/chest_disable.svg";
    // this.currentTab = data.currentTab;
    this.authService?.selectedlanguage$?.subscribe(
      (l) => {
        this.selectedLanguage = l ? l : "en";
        translate.use(l ? l : "en");
        if (l == "es") {
          this.spanish = true;
        }
      },
      (err) => {
        return err;
      }
    );
  }
  async ngOnInit() {
    await this.authService
      ?.getUid("FortuneMissionsComponent")
      ?.then((uid) => {
        this.userId = uid;
      })
      .catch((error) => {
        return error;
      });
    this.socialService
      .socialFortuneLeaderboardPlayerWeek()
      .then((d) => {
        this.getLeaderPlayerWeek$.next(d);
      })
      .catch((error) => {
        return error;
      });

    this.socialservice.getFortuneMissionData$.subscribe((d) => {
      this.fortuneMissionData$.next(d);
    });
  }
  public onSlideChange() {
    this.selectedCard = this.gameMission?.swiperRef?.activeIndex;
  }
  public slideOpts: SwiperOptions = {
    initialSlide: 0,
    speed: 400,
    slidesPerView: 1.25,
    spaceBetween: 10,
    centeredSlides: false,
    slidesOffsetBefore: 20,
    slidesOffsetAfter: 20,
  };
  // This is for the Mission cards  slider parameters
  public cardSlide: SwiperOptions = {
    initialSlide: 1,
    speed: 400,
    slidesPerView: 1,
    spaceBetween: 10,
    slidesPerGroup: 1,
    slideToClickedSlide: true,
    centeredSlides: false,
    pagination: {
      el: ".swiper-pagination",
    },
  };

  startSpinner() {
    this.spinnerAnimation = true;
    this.progressBar = 0;
    this.timer$ = interval(20);
    this.sub = this.timer$?.subscribe(
      (sec) => {
        this.progressBar = 0 + sec;
        this.changeDetectorRef.detectChanges();
      },
      (err) => {
        return err;
      }
    );
  }

  public missionsSliderOptions: SwiperOptions = {
    speed: 400,
    slidesPerView: 1,
    slidesPerGroup: 1,
    spaceBetween: 10,
    slideToClickedSlide: true,
  };

  async missionsDialog() {
    const userData = await this.userManagementService.userDetailsForHome$.pipe(first()).toPromise();
    if (userData) {
      let snapshot;
      if (typeof userData?.peepso_group === "string") {
        snapshot = await this.afs
          .doc(
            `/Global_lookup/peepso_user_groups/${userData?.country_name}/${userData.peepso_group}/missions/fortune_list`
          )
          .get()
          .toPromise();
      } else {
        const peepso_group_url = userData?.peepso_group;
        const path = peepso_group_url["path"];

        snapshot = await this.afs.doc(`${path}/missions/fortune_list`).get().toPromise();
      }
      if (snapshot?.exists) {
        const currentData = snapshot?.data();
        for (let key of Object.keys(currentData)) {
          if (key === "update_timestamp" || key === "creation_timestamp") {
            continue;
          }
          const ref = currentData["current"].get();
          const data = await this.socialService.allPromises(ref, "current");
          this.getAsyncData(data.contributors.get());

          if (data?.join_user) {
            let userAlreadyJoined = data?.join_user.some((user) => user?.user_id === this.userId);
            if (!userAlreadyJoined) {
              data.join_user.push({
                user_id: this.userId,
                wp_user_id: parseInt(localStorage.getItem("wp_user_id")),
              });
              currentData["current"].update(data).then(() => {
                  this.socialService.getFortuneMissionData().then((d) => {
                    this.fortuneMissionData$.next(d);
                    this.matDialog.open(FortuneMissionsPopupComponent, {
                      panelClass: "join-mission-dialog",
                      backdropClass: "cashout-back-drop-color",
                    });
                    this.stopSpinner();
                  });
                })
                .catch((error) => {
                  return error;
                });
            }
          }
        }
      }
    }
  }

  getAsyncData(ref) {
    return new Promise((resolve, reject) => {
      if (!ref) {
        reject(false);
      }
      if (ref) {
        const userId = this.userId;
        const wpUserId = parseInt(localStorage.getItem("wp_user_id"));
        this.getFxpByUserId(wpUserId).subscribe(
          (fxp) => {
            const newContributor = {
              user_id: userId,
              wp_user_id: wpUserId,
              fxp: fxp,
            };
            ref.then((d) => {
              const data = d?.data() || {};
              if (!data.top_contributors) {
                data.top_contributors = [newContributor];
              } else {
                const existingContributor = data.top_contributors.find((contributor) => contributor.user_id === userId);
                if (!existingContributor) {
                  data.top_contributors.push(newContributor);
                }
              }
              d?.ref
                .set(data)
                .then(() => {
                  resolve(data);
                })
                .catch((error) => {
                  reject(error);
                });
            }).catch((error) => {
              return error;
            });
          },
          (error) => {
            reject(error);
          }
        );
      }
    });
  }

  getFxpByUserId(wp_user_id) {
    if (wp_user_id) {
      return this.getLeaderPlayerWeek$.pipe(
        map((data) => data?.current_list.find((contributor) => contributor.wp_user_id == wp_user_id)?.fxp)
      );
    }
  }

  getButtonText(missionData) {
    const userId = this.userId;
    if (missionData) {
      let userAlreadyJoined = missionData.join_user.some((user) => user.user_id === userId);
      if (userAlreadyJoined) {
        this.userAlreadyJoined = true;
        return this.translate.get("missions.Contribution");
      } else {
        this.userAlreadyJoined = false;
        return this.translate.get("missions.Join");
      }
    }
    return this.translate.get("missions.Join");
  }
  stopSpinner() {
    this.progressBar === 100;
    this.sub?.unsubscribe();
    this.spinnerAnimation = false;
    this.proceed = true;
    this.changeDetectorRef.detectChanges();
  }
  getDiff(listOne) {
    if (!listOne) return -1;
    const current = this.previous.find((e) => e.wp_user_id === listOne.wp_user_id)?.fxp;
    if (!current) return -1;
    return current - listOne.fxp;
  }
  getMonth(listOne) {
    if (!listOne) return -1;
    const current = this.previousmonth.find((e) => e.wp_user_id === listOne.wp_user_id)?.fxp;
    if (!current) return -1;
    return current - listOne.fxp;
  }
  getWeek(listOne) {
    if (!listOne) return -1;
    const current = this.previousWeek.find((e) => e.wp_user_id === listOne.wp_user_id)?.fxp;
    if (!current) return -1;
    return current - listOne.fxp;
  }
  getPercent(curr: number, tar: number): number {
    const percent = (curr / tar) * 100;
    return percent | 0;
  }
  getweeks(weeks) {
    const days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
    const d = new Date(weeks.seconds * 1000);
    return days[d.getDay()];
  }
  getRank(data) {
    const userId = parseInt(localStorage.getItem("wp_user_id"));
    if (Number.isNaN(userId) || !data || !Array.isArray(data) || data?.length === 0) {
      return null;
    }
    const sortedData = data.sort((a, b) => b.fxp - a.fxp);
    const userIndex = sortedData.findIndex((d) => d.wp_user_id === userId);
    if (userIndex < 0) {
      return null;
    }
    return userIndex + 1;
  }

  checkCards(currentRestData) {
    if (currentRestData) {
      if (currentRestData && currentRestData?.end && currentRestData?.end instanceof Timestamp) {
        if (currentRestData?.end.toDate() < new Date()) {
          return "completed";
        }

        if (currentRestData?.end.toDate() > new Date()) {
          if (currentRestData?.start && currentRestData?.start instanceof Timestamp) {
            if (currentRestData?.start.toDate() <= new Date()) {
              return "join";
            }
          }
        }

        if (currentRestData?.start && currentRestData?.start instanceof Timestamp) {
          if (currentRestData?.start.toDate() > new Date() && currentRestData?.end.toDate() > new Date()) {
            this.isDisable = true;
            return "joinWithDisable";
          }
        }
      }
    }
  }
}
